import React, { useState, useEffect } from 'react';
import UserAvatarUpload from './UserAvatarUpload';
import TodaysGalleyPlanCard from './TodaysGalleyPlanCard';

import { useAuth } from '../../../contexts/AuthContext';
import { userProfileService } from '../../../services/userProfileService';
import { storageService } from '../../../services/storageService';


const TripStatusCard = ({ trip, onTripUpdate }) => {
  const { user } = useAuth();
  const [avatarUrl, setAvatarUrl] = useState(null);

  useEffect(() => {
    const loadUserAvatar = async () => {
      if (!user?.id) return;

      const { data: profile } = await userProfileService?.getUserProfile(user?.id);

      if (profile?.avatar_url) {
        const { data: signedUrl } = await storageService?.getUserAvatarUrl(profile?.avatar_url);
        if (signedUrl) {
          setAvatarUrl(signedUrl);
        }
      }
    };

    loadUserAvatar();
  }, [user]);

  if (!trip) return null;

  return (
    <div className="bg-card rounded-lg p-4 md:p-6 lg:p-8 shadow-elevation-2">
      <div className="flex items-center gap-3 mb-4">
        <UserAvatarUpload
          userId={user?.id}
          currentAvatarUrl={avatarUrl}
          onAvatarUpdate={setAvatarUrl} />

        <div>
          <h2 className="text-xl md:text-2xl lg:text-3xl font-semibold text-foreground mb-2">
            {trip?.tripName}
          </h2>
          <p className="text-sm md:text-base text-muted-foreground">
            {trip?.crewSize} crew members
          </p>
        </div>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6 mb-6">
        <div className="flex flex-col">
          <span className="text-xs md:text-sm text-muted-foreground mb-1">Total Trip Days</span>
          <span className="text-3xl md:text-4xl lg:text-5xl font-semibold text-foreground data-text">
            {trip?.duration || 0}
          </span>
          <span className="text-xs text-muted-foreground mt-1">
            From trip setup
          </span>
        </div>
        
        <TodaysGalleyPlanCard trip={trip} />
      </div>
    </div>);

};

export default TripStatusCard;